<template>
  <div class="menu-nav">
    <router-link
      class="menu-nav__item"
      :to="{ name: 'individual' }"
      v-slot="{ href, navigate, isActive }"
    >
      <a :href="href" :class="{ '-active': isActive }" @click="navigate">
        Ana Sayfa
      </a>
    </router-link>
    <div class="menu-nav__sub" :class="{ '-active': isPolicy }">
      <div
        class="menu-nav__sub__title"
        @click="openMenuOne()"
        :data-exclude="true"
      >
        Bireysel Emeklilik
      </div>
      <transition name="fade" mode="out-in">
        <div
          class="menu-nav__sub__submenu"
          v-if="menuOne"
          v-click-outside="outsideOne"
        >
          <div class="menu-nav__sub__submenu__contracts">
            <div class="menu-nav__sub__submenu__title">Sözleşmelerim</div>
            <div
              class="menu-nav__sub__box"
              v-for="item in contracts"
              :key="`menu-policy-${item.id}`"
              @click="goPolicyDetail(item)"
            >
              <div class="menu-nav__sub__box__title">
                <span class="-short">{{ item.name }}</span>
                <span>{{ item.person }}</span>
              </div>
              <div class="menu-nav__sub__box__number">
                {{ `${item.total.toLocaleString()} TL` }}
              </div>
            </div>
            <router-link :to="{ name: 'myContracts' }"
              >Tüm Sözleşmelerim</router-link
            >
          </div>
          <div class="menu-nav__sub__submenu__links">
            <div class="menu-nav__sub__submenu__title">Linkler</div>
            <router-link
              class="menu-nav__sub__submenu__link"
              :to="{ name: 'besCalculationTools' }"
              >Hesaplama Araçları</router-link
            >
            <router-link
              class="menu-nav__sub__submenu__link"
              :to="{ name: 'forms' }"
              >Formlar</router-link
            >
            <!-- <div class="menu-nav__sub__submenu__link">Fon Asistanı</div> -->
          </div>
        </div>
      </transition>
    </div>
    <div class="menu-nav__sub" :class="{ '-active': isInsurance }">
      <div
        class="menu-nav__sub__title"
        @click="openMenuTwo()"
        :data-exclude="true"
      >
        Sigortalar
      </div>
      <transition name="fade" mode="out-in">
        <div
          class="menu-nav__sub__submenu"
          v-if="menuTwo"
          v-click-outside="outsideTwo"
        >
          <div class="menu-nav__sub__submenu__contracts">
            <div class="menu-nav__sub__submenu__title">Poliçelerim</div>
            <div
              class="menu-nav__sub__box"
              v-for="item in insuranceFilterData"
              :key="`menu-insurance-${item.id}`"
              @click="goInsuranceDetail(item)"
            >
              <div class="menu-nav__sub__box__title">
                <span>{{ item.name }}</span>
                <span>{{ item.id }} No’lu Poliçe</span>
              </div>
            </div>
            <router-link :to="{ name: 'myInsurances' }"
              >Tüm Poliçelerim</router-link
            >
          </div>
          <div class="menu-nav__sub__submenu__links">
            <div class="menu-nav__sub__submenu__title">Linkler</div>
            <router-link
              class="menu-nav__sub__submenu__link"
              :to="{ name: 'contractedHealthInstitutions' }"
              >Anlaşmalı Sağlık Kuruluşları</router-link
            >
            <router-link
              class="menu-nav__sub__submenu__link"
              :to="{ name: 'forms' }"
              >Formlar</router-link
            >
            <router-link
              class="menu-nav__sub__submenu__link"
              :to="{ name: 'paidEmployee' }"
              >Vergi Avantajı Hesaplama</router-link
            >
            <router-link
              class="menu-nav__sub__submenu__link"
              :to="{ name: 'pastInsurance' }"
              >Geçmiş Poliçelerim</router-link
            >
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { clickOutside } from "@/directives/";
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      menuOne: false,
      menuTwo: false,
      contracts: [],
      policies: [],
    };
  },
  directives: {
    "click-outside": clickOutside,
  },
  watch: {
    $route() {
      this.menuOne = false;
      this.menuTwo = false;
    },
  },
  computed: {
    isPolicy: function () {
      return this.$route.path.includes("/home/bes");
    },
    isInsurance: function () {
      return this.$route.path.includes("/home/insurance");
    },
    insuranceFilterData: function () {
      return this.policies
        .flat()
        .sort((a, b) => b.total - a.total)
        .filter((item, index) => index < 4);
    },
  },
  created() {
    this.createContractsData();
    this.createPoliciesData();
  },
  methods: {
    createContractsData: async function () {
      let vm = this;

      vm.contracts = vm.data.contracts
        .filter((item) => item.birikimTipAciklama == "BES")
        .map((item) => {
          return {
            id: item.policyNo,
            name: item.tarifeAd,
            person: item.katilimciAdSoyad,
            total: parseInt(item.fonBuyukluguDK + item.fonBuyukluguKK),
            type: item.type,
          };
        })
        .filter((item) => item.type == "me")
        .sort((a, b) => b.total - a.total)
        .filter((item, index) => index < 4);

      let policies = vm.data.contracts
        .filter((item) => item.birikimTipAciklama == "Birikimsiz Hayat")
        .map((item) => {
          return {
            id: item.policyNo,
            name: item.tarifeAd,
            person: item.katilimciAdSoyad,
            total: parseInt(item.fonBuyukluguDK + item.fonBuyukluguKK),
            type: item.type,
          };
        })
        .filter((item) => item.type == "me");

      vm.policies.push(policies);
    },
    createPoliciesData: async function () {
      let vm = this;

      let data = vm.data.policies
        .filter((item) => item.customerRoleId == 1 && item.policystatusId != 5)
        .map((item) => {
          return {
            id: item.policyId,
            name: item.productName,
            type: item.type,
            total: item.debtAmount,
          };
        });

      vm.policies.push(data);
    },
    openMenuOne: function () {
      this.menuOne = !this.menuOne;
      this.menuTwo = false;
    },
    outsideOne: function () {
      this.menuOne = false;
    },
    openMenuTwo: function () {
      this.menuTwo = !this.menuTwo;
      this.menuOne = false;
    },
    outsideTwo: function () {
      this.menuTwo = false;
    },
    goPolicyDetail: function (item) {
      let vm = this;

      if (vm.$route.fullPath === `/home/bes/detail/${item.id}/summary`)
        return (vm.menuOne = false);

      vm.menuOne = false;

      vm.$router.push({
        name: "besDetail",
        params: { contract: item.id },
      });
    },
    goInsuranceDetail: function (item) {
      let vm = this;

      if (vm.$route.fullPath === `/home/insurance/detail/${item.id}/summary`)
        return (vm.menuTwo = false);

      vm.menuTwo = false;

      vm.$router.push({
        name: "insuranceDetail",
        params: {
          policy: item.id,
        },
      });
    },
  },
};
</script>